import { Injectable } from '@angular/core';

import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { format, parse } from 'date-fns';

@Injectable()
export class DateParserFormatter extends NgbDateParserFormatter {
  readonly FORMAT = `dd/MM/yyyy`;

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = parse(value, this.FORMAT, new Date());
      return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
      };
    }

    return null;
  }

  format(value: NgbDateStruct | null): string {
    if (value) {
      let month = value.month.toString();
      if (value.month.toString().length === 1) {
        month = `0${value.month}`;
      }
      const date = parse(`${value.year}${month}${value.day}`, 'yyyyMMd', new Date());
      return format(date, this.FORMAT);
    }

    return '';
  }
}
